module.exports = __webpack_public_path__ + "static/photos-b2354c8401043e507e729c137e8522de.jpg";